// /home/cockskiz/new.greatlysocial.com/frontend/src/pages/dashboard/post/previews/NetworkPreviewHub.js
import React, { useState, useEffect } from 'react';

import InstagramPreview from './InstagramPreview';
import LinkedInPreview  from './LinkedInPreview';
import FacebookPreview  from './FacebookPreview';
import XPreview         from './XPreview';          // Twitter
import TikTokPreview    from './TikTokPreview';
import ThreadsPreview   from './ThreadsPreview';
import YouTubePreview   from './YouTubePreview';
import PinterestPreview from './PinterestPreview';

const MAP = {
  instagram : InstagramPreview,
  linkedin  : LinkedInPreview,
  facebook  : FacebookPreview,
  x         : XPreview,
  twitter   : XPreview,      // alias
  tiktok    : TikTokPreview,
  threads   : ThreadsPreview,
  youtube   : YouTubePreview,
  pinterest : PinterestPreview,
};

export default function NetworkPreviewHub({
  accounts,
  caption,
  files,
  postType,
  scheduleDateTime,
}) {
  /* ---- hooks must come first ---- */
  const [active, setActive] = useState(
    accounts.length ? accounts[0].platform : ''
  );

  /* sync active tab when account list changes */
  useEffect(() => {
    if (!accounts.length) {
      setActive('');          // nothing selected
    } else if (!accounts.some(a => a.platform === active)) {
      setActive(accounts[0].platform); // reset to first available
    }
  }, [accounts, active]);

  /* fallback view before accounts are chosen */
  if (!accounts.length)
    return <p className="text-muted">Select an account to see preview</p>;

  const ActiveCmp = MAP[active] || (() => <p>No preview yet</p>);

  return (
    <>
      {/* pill bar */}
      <ul className="nav nav-pills mb-3">
        {accounts.map((a) => (
          <li className="nav-item" key={a.platform + a.id}>
            <button
              className={`nav-link ${active === a.platform ? 'active' : ''}`}
              onClick={() => setActive(a.platform)}
            >
              {a.platform.charAt(0).toUpperCase() + a.platform.slice(1)}
            </button>
          </li>
        ))}
      </ul>

      {/* active preview */}
      <ActiveCmp
        account={accounts.find((a) => a.platform === active)}
        files={files}
        caption={caption}
        postType={postType}
        scheduleDateTime={scheduleDateTime}
      />
    </>
  );
}
